import { GetTopicsMeta, GetTopicsPayload } from 'types/store/GetTopics';
import { createAsyncReducer } from 'utils/Redux';

import { getTopicsActions } from '../actions';

export default createAsyncReducer<GetTopicsMeta, GetTopicsPayload>(
  getTopicsActions
);
